import React from "react";
import { SmallText } from "../styles/appstyles";
import {
  IconContainer,
  IconLabel,
  InputWrapper,
  StyledInput,
  UnitContainer,
} from "./componentsStyles";
import { CiCircleInfo } from "react-icons/ci";

const Input = ({ handleInputChange, name, label, icon, unit, value, type }) => {
  return (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <IconLabel style={{ color: "#343541", opacity: "0.6" }}>
          {label}
        </IconLabel>
        <>
          <CiCircleInfo style={{ position: "relative", bottom: "1px" }} />
        </>
      </div>
      <InputWrapper>
        <IconContainer>{icon}</IconContainer>
        <StyledInput
          type={type ?? "text"}
          onChange={(e) => {
            handleInputChange(e.target.value, name);
          }}
          value={value}
        />
        {unit ? (
          <UnitContainer>
            <SmallText style={{ fontSize: "16px" }}>{unit}</SmallText>
          </UnitContainer>
        ) : null}
      </InputWrapper>
    </>
  );
};

export default Input;
